// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

require("@rails/ujs").start()
require("@rails/activestorage").start()
require("channels")
require("packs/main")

const jQuery = require('jquery')
window.$ = jQuery
window.jQuery = jQuery

// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)

(function ($) {
  $.fn.detectPostcode = function() {
    $('.postcode').on('keyup', function() {
      let postcode = $(this).val().replace(/-/g, '');

      $('.prefecture').val('');
      $('.city').val('');

      if (postcode.length === 7) {
        $.ajax({
          url: $(this).data('url'),
          type: 'GET',
          dateType: 'json',
          data: { postcode },
          success: function(data) {
            if (data.length) {
              let address = data[0].town ? data[0].city + " " + data[0].town : data[0].city

              $('.prefecture').val(data[0].prefecture);
              $('.city').val(address);
            } else {
              $('.prefecture').val('');
              $('.city').val('');
            }
          },
        });
      }
    });
  }

  $.fn.hideSelectOperationNextStepButton = function() {
    const operationAmount = $("input[type='radio'][name='form_reservations_operation[operation_id]']").length;
    const disabledOperationAmount = $("input[type='radio'][name='form_reservations_operation[operation_id]']:disabled").length;

    if (operationAmount == disabledOperationAmount) {
      $('.button.next').remove();
    }
  }
})
